import useServiceFactory from "../serviceFactory";
const apiUrl = `/taller/mantenimiento/OrdenesTrabajo`;

const useApiOrdenServicio = () => {
  const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });

  return {
    filtrar: async (params) => service.get(`${apiUrl}`, { params }),
    obtener: async (id) => service.get(`${apiUrl}/${id}`, {}),
    guardar: async (params) => service.post(`${apiUrl}`, params),
    obtenerUnidad: async (id) => service.put(`${apiUrl}/unidades/${id}`, {}),
    obtenerServicios: async (id) => service.put(`${apiUrl}/mantenimientos/${id}/actividades`, {}),
    obtenerSolicitudServicio: async (unidadId) => service.get(`${apiUrl}/solicitud/${unidadId}`, {}),
    obtenerRefacciones: async (id) => service.put(`${apiUrl}/actividades/${id}/refacciones`, {}),
    ultimasOrdenes: async (id) => service.get(`${apiUrl}/ultimasOrdenes/${id}`, { showLoading: true }),
    esReprogramacion: async (id, params) => service.get(`${apiUrl}/${id}/esReprogramacion`, { params }),
    actualizar: async (id, params) => service.put(`${apiUrl}/${id}`, params),
    cancelar: async (id, params) => service.patch(`${apiUrl}/${id}/cancelar`, params),
    obtieneCheckList: async (id) => service.get(`${apiUrl}/checkList/${id}`, {}),
    confirmar: async (id, params) => service.put(`${apiUrl}/${id}/confirmar`, params),
    terminarOrden: async (id, params) => service.put(`${apiUrl}/${id}/terminarOrden`, params),
    subirFormato: async (id, formData) => service.post(`${apiUrl}/${id}/formato`, formData),
    reabrir: async (id, params) => service.patch(`${apiUrl}/${id}/reabrir`, params),
    excel: async (params) =>
      service.get(`${apiUrl}/excel`, {
        params,
        showLoading: true,
        download: true,
        fileName: `OrdenesDeTrabajo.xlsx`,
      }),
    entradaTaller: async (id, params) => service.put(`${apiUrl}/entradaTaller/${id}`, params),

    obtenerInfoOperador: async (empleadoId) =>
      service.get(`${apiUrl}/operador/${empleadoId}/info`, { showLoading: true }),
  };
};

export default useApiOrdenServicio;
